import React from 'react';
import PhotoGallery from '../PhotoGallery/PhotoGallery';
import TabEmpty from '../TabEmpty/TabEmpty';
import { ITabPhotosProps } from './TabPhotos.types';

const TabPhotos: React.FC<ITabPhotosProps> = ({ inspection }) => {
  const { photos } = inspection;

  // Filtrar fotos excluindo as com origin UPLOAD_KITE_REGULATION
  const filteredPhotos = photos?.filter((photo) => photo.origin !== 'UPLOAD_KITE_REGULATION') || [];

  if (!filteredPhotos.length) {
    return <TabEmpty title="Não há fotos capturadas" />;
  }

  // Criar uma cópia da inspection com as fotos filtradas
  const inspectionWithFilteredPhotos = {
    ...inspection,
    photos: filteredPhotos,
  };

  return <PhotoGallery inspection={inspectionWithFilteredPhotos} />;
};

export default TabPhotos;
